/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { CampaignType } from 'cio/models/campaign';

interface TriggerTypeSelectorCardArgs {
  type: {
    id: string;
    icon: string;
    label: string;
    description?: string;
  };
  selectedType: CampaignType;
  onChangeType: () => unknown;
  triggerIsSaved: boolean;
}

export default class TriggerTypeSelectorCard extends Component<TriggerTypeSelectorCardArgs> {}
